import React, { memo } from 'react'

import { Link } from 'react-router-dom'

import { Icon, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  bool, elementType, func, string,
} from 'prop-types'

import DesktopOnlyTooltip from 'Pods/Shared/DesktopOnlyTooltip/DesktopOnlyTooltip'
import { iconSizeNav } from 'Pods/ThreeDStudio/constants'

import { NOOP } from 'Utils/stableDefaults'

function NavItem({
  to,
  label,
  icon,
  tooltipId,
  isActive = false,
  isOpen = true,
  onClick = NOOP,
  onMouseEnter = NOOP,
  onFocus = NOOP,
}) {
  const link = (
    <Link
      to={to}
      className={classnames(
        'link-nav__item cgt-body-base-semibold',
        isActive && 'link-nav__item--active',
      )}
      aria-label={label}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onFocus={onFocus}
    >
      <Icon
        svgComponent={icon}
        size={iconSizeNav}
        color={isActive ? 'primary' : 'darker'}
        notSpaced
      />
      {isOpen && <span>{label}</span>}
    </Link>
  )

  if (isOpen) {
    return link
  }

  return (
    <DesktopOnlyTooltip content={label} id={tooltipId} place="right">
      {link}
    </DesktopOnlyTooltip>
  )
}

NavItem.propTypes = {
  to: string.isRequired,
  label: string.isRequired,
  icon: elementType.isRequired,
  tooltipId: string.isRequired,
  isActive: bool,
  isOpen: bool,
  onClick: func,
  onMouseEnter: func,
  onFocus: func,
}

export default memo(NavItem)
